var map = {
	"./character-disappointed.svg": [
		3782,
		1609
	],
	"./character-embarrassed.svg": [
		3783,
		1608
	],
	"./character-greedy.svg": [
		3784,
		1607
	],
	"./character-happy.svg": [
		3785,
		1606
	],
	"./character-sad.svg": [
		3786,
		1605
	],
	"./character-searching.svg": [
		3787,
		1604
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2186;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img lazy ^\.\/character\-.*\.svg$
// module id = 2186
// module chunks = 1611